import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import useApi from '../../api/useApi';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { NumericFormat } from 'react-number-format';
import Moment from 'react-moment';//Both are required here
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';

const LotDetailReport = () => {
    const { id } = useParams();
    const [reportData, setReportData] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const [selectedRow, setSelectedRow] = useState({});
    const [modalVisible, setModalVisible] = useState(false);
    const navigate = useNavigate();
    const api = useApi();

    const loadReport = async () => {
        const params = {
            AuctionId: parseInt(id)
        }
        await api.getReport('LotDetail', params).then((data) => {
            setReportData(data);
        })
    }

    useEffect(() => {
        loadReport();
    }, []);

    const dateRenderer = (props, format) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span>{cellValue ? <Moment format={format}>{cellValue}</Moment> : null}</span>
            </span>
        );
    };

    const viewSummaryReport = () => {
        setModalVisible(true);
    };

    const viewBiddingHistoryReport = (lotId) => {
        navigate(`/biddingHistoryReport/${lotId}`);
    };

    const handleClose = () => {
        setModalVisible(false);
    };

    const buttonRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span role="button" className="custom-link" onClick={() => viewBiddingHistoryReport(cellValue)}>
                    <button className="btn ripple btn-outline-primary btn-sm mb-b-4" type="button" onClick={exportToExcel}>
                        Bidding History
                    </button>
                </span>
            </span>
        );
    };

    const qtyRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span><NumericFormat suffix={' Kg'} displayType="text" value={cellValue} allowLeadingZeros thousandSeparator="," decimalScale={2} /> </span>
            </span>
        );
    };

    const amountRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span><NumericFormat prefix={'₹ '} displayType="text" value={cellValue} allowLeadingZeros thousandSeparator="," decimalScale={2} /> </span>
            </span>
        );
    };

    const columns = [
        { headerName: '', field: 'LotId', headerClass: 'text-center', cellClass: 'text-center', width: 120, cellRenderer: buttonRenderer },
        { headerName: 'Lot Number', field: 'LotNumber', headerClass: 'text-center', cellClass: 'text-center', width: 70 },
        { headerName: 'Quantity (Kg)', field: 'QuantityKg', cellClass: 'text-center', width: 70 },
        { headerName: 'Litre Weight (Gms)', field: 'LitreWeightGms', cellClass: 'text-center', width: 70 },
        { headerName: 'Bags', field: 'Bags', cellClass: 'text-center', width: 50 },
        { headerName: 'Planter Dealer', field: 'PlanterDealer', cellClass: 'text-center', width: 70 },
        { headerName: 'Status', field: 'LotStatus', headerClass: 'text-center', width: 70 },
        { headerName: 'Planter Name', field: 'PlanterName', headerClass: 'text-center', width: 220 },
        { headerName: 'CRNOSBL No', field: 'CRNOSBLNo', cellClass: 'text-center', width: 150 },
        { headerName: 'Collection Centre', field: 'CollectionCentre', headerClass: 'text-center', width: 150 },
        { headerName: 'Grade Type', field: 'GradeType', cellClass: 'text-center', width: 60 },
        { headerName: 'Grade', field: 'Grade', cellClass: 'text-center', width: 60 },
        { headerName: 'Reserved Price', field: 'ReservedPrice', cellClass: 'text-center', width: 80 },
        { headerName: 'Auction Start Price (Rs)', field: 'AuctionStartPriceRs', cellClass: 'text-center', width: 80 },
        { headerName: 'Final Price (Rs)', field: 'FinalPrice', cellClass: 'text-center', width: 80 },
        { headerName: 'Immature Seeds', field: 'ImmatureSeeds', cellClass: 'text-center', width: 80 },
        { headerName: 'Moisture Content', field: 'MoistureContent', cellClass: 'text-center', width: 80 },
        { headerName: 'Planter Mobile Number', field: 'PlanterMobileNumber', cellClass: 'text-center', width: 110 },
        { headerName: 'Suspected Lot', field: 'IsSuspectedLot', cellClass: 'text-center', width: 90 },
        { headerName: 'Colored Lot', field: 'IsColoredLot', cellClass: 'text-center', width: 90 },
        { headerName: 'Special Lot', field: 'IsSpecialLot', cellClass: 'text-center', width: 90 },
    ];

    const gridOptions = {
        defaultColDef: {
            wrapHeaderText: true,
            autoHeaderHeight: true,
            sortable: false,
        },
        rowSelection: 'single',
        suppressRowClickSelection: true,
        columnDefs: columns,
        //autoSizeStrategy: { type: 'fitCellContents' },
        rowClass: 'custom-grid-font',
        getRowClass: params => {
            if (params.node.rowIndex % 2 === 0) {
                return 'bg-gray-50-i';
            }
        }
    };

    const onGridReady = (params) => {
        setGridApi(params.api);
    };

    const onSelectionChanged = () => {
        const selectedRows = gridApi.getSelectedRows();
        setSelectedRow(selectedRows[0]);
        console.log('Selected Rows:', selectedRows);
    };

    const exportToExcel = () => {

        const params = {
            suppressQuotes: false,
            columnSeparator: ',',
        };

        const data = gridApi.getDataAsCsv(params);

        const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
        const fileName = 'Auction Price Report.csv';

        const link = document.createElement('a');
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    return (
        <div className="inner-body">
            <div className="page-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">Lot Detail Report</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a className="custom-link" onClick={() => navigate('/home')}>Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Lot Detail Report</li>
                    </ol>
                </div>
                <div className="d-flex">
                    <div className="justify-content-center">
                        {/*<button className="btn ripple btn-outline-danger pd-x-10 mg-r-10 btn-sm" type="button" onClick={exportToPdf}>*/}
                        {/*    <i class="ti ti-import me-2"></i>Export to pdf*/}
                        {/*</button>*/}
                        <button className="btn ripple btn-outline-primary pd-x-10 mg-r-5 btn-sm" type="button" onClick={exportToExcel}>
                            <i class="ti ti-import me-2"></i>Export to csv
                        </button>
                    </div>
                </div>
            </div>
            <div className="row row-sm">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between mg-b-8">
                                <div>
                                    {reportData ?
                                        <div className="d-flex flex-column justify-content-start">
                                            <div>Auctioneer :<strong> {reportData[0]?.CompanyName}</strong></div>
                                            <div>Auction No / Date : <strong> {reportData[0]?.AuctionNo} / <Moment format="DD-MMM-YYYY">{reportData[0]?.AuctionDate}</Moment> </strong></div>
                                        </div>
                                        : null}
                                </div>
                                <div>
                                    <input type="text" className="form-control" placeholder="type to filter"></input>
                                </div>
                            </div>
                            <div
                                style={{ height: 500 }}
                                className={
                                    "ag-theme-alpine"
                                }
                            >
                                <AgGridReact
                                    rowHeight={36}
                                    gridOptions={gridOptions}
                                    rowData={reportData}
                                    onGridReady={onGridReady}
                                    onSelectionChanged={onSelectionChanged}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {/*size='lg'*/}
            <Modal show={modalVisible} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Auction Summary</Modal.Title>
                </Modal.Header>
                <Modal.Body className="pd-x-40">
                    <div className="row">
                        <table className="table">
                            <tbody >
                                <tr className="border-bottom pd-4">
                                    <th>Auction Id : </th>
                                    <td>{selectedRow?.AuctionId}</td>
                                </tr>
                                <tr className="border-bottom ">
                                    <th>Auctioneer Name : </th>
                                    <td>{selectedRow?.CompanyName}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Auction Number : </th>
                                    <td>{selectedRow?.AuctionNo}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Total Lots : </th>
                                    <td>{selectedRow?.TotalLots}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Total Quantity : </th>
                                    <td>{selectedRow?.TotalArrivals}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Total Sold Quantity :</th>
                                    <td>{selectedRow?.TotalSales}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Total Sell Value : </th>
                                    <td>{selectedRow?.TotalSaleValue}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Total Bids :</th>
                                    <td>{selectedRow?.TotalBids}</td>
                                </tr>
                                <tr className="border-bottom">
                                    <th>Total Bidders :</th>
                                    <td>{selectedRow?.TotalBidders}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </Modal.Body>
            </Modal>
        </div>
    );
};

export default LotDetailReport;



